import getUTCNoonForDate from './getUTCNoonForDate';

const convertDateToBackendFormat = dateValue => {
  let parsedDateValue;
  if (!dateValue) {
    return null;
  }
  if (dateValue instanceof Date) {
    parsedDateValue = dateValue.getTime();
  } else if (typeof dateValue === 'number') {
    parsedDateValue = dateValue;
  } else {
    try {
      parsedDateValue = getUTCNoonForDate(dateValue);
    } catch (e) {
      parsedDateValue = Date.parse(dateValue) + 10800000 || null;
    }
  }
  return parsedDateValue;
};

const getRuleForTwoDates = dateLogicFields => {
  const { firstDate, secondDate } = dateLogicFields;
  return {
    op: 'between',
    value: [
      {
        type: 'date',
        value: convertDateToBackendFormat(firstDate)
      },
      {
        type: 'date',
        value: convertDateToBackendFormat(secondDate)
      }
    ],
    deleteKeys: ['intervalUnit', 'intervalCount']
  };
};

const getRuleForFutureOrPast = dateLogicFields => {
  const {
    anytimeDropdownValue,
    comparisonDropdownValue,
    firstIntervalCount,
    firstIntervalUnit,
    secondIntervalCount,
    secondIntervalUnit
  } = dateLogicFields;
  if (secondIntervalCount) {
    return {
      op: 'between',
      value: [
        {
          type: 'interval',
          op: comparisonDropdownValue === 'future' ? 'plus' : 'minus',
          intervalUnit: firstIntervalUnit,
          intervalCount: firstIntervalCount
        },
        {
          type: 'interval',
          op: comparisonDropdownValue === 'future' ? 'plus' : 'minus',
          intervalUnit: secondIntervalUnit,
          intervalCount: secondIntervalCount
        }
      ],
      deleteKeys: ['intervalUnit', 'intervalCount', 'type']
    };
  } else if (firstIntervalCount) {
    if (comparisonDropdownValue === 'future') {
      if (anytimeDropdownValue === 'more') {
        return {
          op: '>',
          type: 'interval',
          value: 'now',
          intervalUnit: firstIntervalUnit,
          intervalCount: firstIntervalCount
        };
      } else {
        return {
          op: 'between',
          type: 'interval',
          value: [
            {
              type: 'interval',
              op: 'plus',
              intervalUnit: firstIntervalUnit,
              intervalCount: firstIntervalCount
            },
            {
              type: 'date',
              value: 'now'
            }
          ],
          deleteKeys: ['intervalUnit', 'intervalCount']
        };
      }
    } else if (comparisonDropdownValue === 'past') {
      if (anytimeDropdownValue === 'more') {
        return {
          op: '<',
          type: 'interval',
          value: 'now',
          intervalUnit: firstIntervalUnit,
          intervalCount: firstIntervalCount
        };
      } else {
        return {
          op: 'between',
          type: 'interval',
          value: [
            {
              type: 'date',
              value: 'now'
            },
            {
              type: 'interval',
              op: 'minus',
              intervalUnit: firstIntervalUnit,
              intervalCount: firstIntervalCount
            }
          ],
          deleteKeys: ['intervalUnit', 'intervalCount']
        };
      }
    }
  } else {
    return {
      op: comparisonDropdownValue === 'future' ? '>' : '<',
      value: 'now',
      deleteKeys: ['type', 'intervalUnit', 'intervalCount']
    };
  }
};

const getRuleForSingleDate = dateLogicFields => {
  const { comparisonDropdownValue, firstDate } = dateLogicFields;
  return {
    op: comparisonDropdownValue,
    value: convertDateToBackendFormat(firstDate),
    deleteKeys: ['type', 'intervalUnit', 'intervalCount']
  };
};

const dateLogicFieldsToDateRule = dateLogicFields => {
  const { comparisonDropdownValue } = dateLogicFields;
  switch (comparisonDropdownValue) {
    case 'blank':
      return {
        op: '=',
        value: '',
        deleteKeys: ['intervalUnit', 'intervalCount', 'type']
      };
    case 'not_blank':
      return {
        op: '<>',
        value: '',
        deleteKeys: ['intervalUnit', 'intervalCount', 'type']
      };
    case 'between':
      return getRuleForTwoDates(dateLogicFields);
    case 'future':
    case 'past':
      return getRuleForFutureOrPast(dateLogicFields);
    default:
      return getRuleForSingleDate(dateLogicFields);
  }
};

export default dateLogicFieldsToDateRule;
